import { Registry } from '@react-registry'

export const HR = () => {
    return {
        type: 'hr'
    }
}

Registry.register(HR, { id: 'HR', registry: 'deserializer' })